import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=5ebb49ea&scoped=true&"
import script from "./ProductView.vue?vue&type=script&lang=ts&"
export * from "./ProductView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductView.vue?vue&type=style&index=1&id=5ebb49ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb49ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ebb49ea')) {
      api.createRecord('5ebb49ea', component.options)
    } else {
      api.reload('5ebb49ea', component.options)
    }
    module.hot.accept("./ProductView.vue?vue&type=template&id=5ebb49ea&scoped=true&", function () {
      api.rerender('5ebb49ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductView.vue"
export default component.exports